<template>
  <div>
    <div class="form-group">
      <label class="control-label col-md-2">Location Search:</label>
      <div class="col-md-10">
        <div class="input-group">
          <input
            type="text"
            name="accident_location"
            v-model="search"
            class="form-control"
          />
          <div class="input-group-btn">
            <button
              type="button"
              class="btn btn-primary"
              v-on:click="findIncident"
              name="find_location"
            >
              Find Location
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="map-container">
      <div id="map"></div>
      <div id="streetView"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    lat: [Number, String],
    lng: [Number, String],
    location: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      marker: null,
      search: this.location
    };
  },

  computed: {
    latLng() {
      if (this.marker) {
        return {
          lat: parseFloat(this.marker.lat),
          lng: parseFloat(this.marker.lng)
        };
      }

      return {
        lat: 52.70465666042159,
        lng: -1.3403320287500264
      };
    }
  },

  mounted() {
    window.GoogleMapsLoader.load(google => {
      let options = {
        scrollwheel: false,
        center: this.latLng,
        zoom: 14
      };

      window.map = new google.maps.Map(document.getElementById('map'), options);
      let streetView = new google.maps.StreetViewPanorama(
        document.getElementById('streetView'),
        {
          position: this.latLng,
          pov: {
            heading: 34,
            pitch: 10
          }
        }
      );

      window.map.setStreetView(streetView);
    });
  },

  methods: {
    createMap() {
      let element = document.getElementById('map');
      window.map = new window.google.maps.Map(element, {
        scrollwheel: false,
        zoom: 6,
        center: this.latLng
      });
      window.marker = new window.google.maps.Marker({
        position: this.latLng,
        map: window.map,
        title: 'Accident Location'
      });
    },

    findIncident() {
      let request = new XMLHttpRequest();

      request.onreadystatechange = () => {
        if (request.readyState === XMLHttpRequest.DONE) {
          let data = JSON.parse(request.response);

          this.marker = {
            lat: parseFloat(data.results[0].geometry.location.lat),
            lng: parseFloat(data.results[0].geometry.location.lng)
          };

          window.map.setCenter(
            new window.google.maps.LatLng(this.marker.lat, this.marker.lng)
          );

          let streetView = new window.google.maps.StreetViewPanorama(
            document.getElementById('streetView'),
            {
              scrollwheel: false,
              position: this.marker,
              pov: {
                heading: 34,
                pitch: 10
              }
            }
          );

          window.map.setStreetView(streetView);
        }
      };

      request.open(
        'GET',
        'https://maps.googleapis.com/maps/api/geocode/json?address=' +
          this.search +
          '&key=AIzaSyCYSEv6QzAPFbjZaAXGApLUeW6nFjwDpg8',
        true
      );
      request.send();
    }
  },

  watch: {
    location(value) {
      this.search = value;
    },

    lat(value) {
      if (this.marker) {
        this.marker.lat = value;
      } else {
        this.marker = {
          lat: value,
          lng: this.lng
        };
      }
    },

    latLng(value) {
      if (value) {
        let center = new window.google.maps.LatLng(value.lat, value.lng);
        window.map.panTo(center);
        window.map.setZoom(16);

        let streetView = new window.google.maps.StreetViewPanorama(
          document.getElementById('streetView'),
          {
            position: {
              lat: value.lat,
              lng: value.lng
            },
            pov: {
              heading: 34,
              pitch: 10
            }
          }
        );

        window.map.setStreetView(streetView);

        this.$emit('located', {
          map: {
            latitude: value.lat,
            longitude: value.lng,
            pitch: window.map.streetView.pov.pitch,
            heading: window.map.streetView.pov.heading
          },
          location: this.search
        });
      }
    }
  }
};
</script>
<style scoped>
#map-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

#map {
  width: 50%;
}
</style>
